var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewPricingEnterpriseIcon = function SvgNewPricingEnterpriseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 70,
    fill: "none",
    viewBox: "0 0 71 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#323338",
    strokeLinejoin: "round",
    strokeWidth: 3.985,
    d: "m36.098 2 12.261 12.735c.523.543.855 1.242.946 1.99l5.757 47.392a3.474 3.474 0 0 1-3.45 3.893H35.848M36.097 2l-12.953 9.603a3.47 3.47 0 0 0-1.378 2.36L19.788 29.76l-4.297 34.344a3.474 3.474 0 0 0 3.447 3.905h16.91M36.097 2l-.052 13.572-.199 52.438"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323338",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.985,
    d: "m19.634 34.426 9.264-5.79M20.79 21.687l6.95-4.632M18.474 47.166l12.739-6.949"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#323338",
    d: "m56.334 21.759 5.235 2.302a5.47 5.47 0 0 1 3.189 4.09l5.947 35.05c.566 3.337-2.005 6.38-5.39 6.38h-3.991v-3.984h3.991c.918 0 1.614-.825 1.461-1.729l-5.947-35.05a1.48 1.48 0 0 0-.864-1.11l-4.433-1.948v-4.354zm2.674 46.807a1.98 1.98 0 0 1 0-1.953zM9.31 35.331a5.47 5.47 0 0 0-3.64 3.974L.141 63.307C-.646 66.732 1.956 70 5.47 70h3.74v-3.985H5.47a1.482 1.482 0 0 1-1.444-1.814l5.527-24.002a1.48 1.48 0 0 1 .985-1.077l3.305-1.07v-4.19z"
  })));
};
export default SvgNewPricingEnterpriseIcon;